import type {IParsedPricesSearchQuery, IPricesSearchCityToken} from "../../types/IPricesSearchModel";
import {isHouseNumberToken} from "./compare_house_numbers";
import {findPricesCityByName, resolveQueryDiacritics} from "./resolve_query_diacritics";
import {getPricesSearchTokens, limitRcnQueryTokens, splitPricesSearchTokens} from "./sanitize_rcn_query_tokens";

/**
 * Splits the typed phrase into what the model needs: the city it names, the building number (the last number-like
 * word, when it is not the only word - "1 maja" is a street, "puławska 257" an address), the words a street is
 * scored against, and the query sent to RCN with its `baseKey`.
 */
export const parsePricesSearchQuery = (raw: string): IParsedPricesSearchQuery => {
    const tokens = splitPricesSearchTokens(raw);
    const cleanTokens = getPricesSearchTokens(raw);

    const cityTokens: IPricesSearchCityToken[] = [];
    const otherTokens: string[] = [];
    for (const token of cleanTokens) {
        const city = findPricesCityByName(token);
        if (city) {
            cityTokens.push({token, citySlug: city.slug, canonical: city.name});
        } else {
            otherTokens.push(token);
        }
    }

    const lastOtherToken = otherTokens[otherTokens.length - 1];
    const numberToken = cleanTokens.length > 1 && lastOtherToken !== undefined && isHouseNumberToken(lastOtherToken) ? lastOtherToken : undefined;
    const restTokens = numberToken === undefined ? otherTokens : otherTokens.slice(0, -1);

    const resolved = resolveQueryDiacritics(cleanTokens);
    const rcnQuery = limitRcnQueryTokens(resolved.tokens).join(" ");

    return {
        raw,
        tokens,
        cityTokens,
        ...(numberToken === undefined ? {} : {numberToken}),
        restTokens,
        rcnQuery,
        // RCN matches street diacritics literally: "puławska" and "pulawska" are different requests, so different phrases.
        baseKey: rcnQuery,
        ...(resolved.isRewritten ? {diacriticPhrase: rcnQuery} : {})
    };
};
import type {IParsedPricesSearchQuery, IPricesSearchCityToken} from "../../types/IPricesSearchModel";
import {isHouseNumberToken} from "./compare_house_numbers";
import {findPricesCityByName, resolveQueryDiacritics} from "./resolve_query_diacritics";
import {getPricesSearchTokens, limitRcnQueryTokens, splitPricesSearchTokens} from "./sanitize_rcn_query_tokens";

/**
 * Splits the typed phrase into what the model needs: the city it names, the building number (the last number-like
 * word, when it is not the only word - "1 maja" is a street, "puławska 257" an address), the words a street is
 * scored against, and the query sent to RCN with its `baseKey`.
 */
export const parsePricesSearchQuery = (raw: string): IParsedPricesSearchQuery => {
    const tokens = splitPricesSearchTokens(raw);
    const cleanTokens = getPricesSearchTokens(raw);

    const cityTokens: IPricesSearchCityToken[] = [];
    const otherTokens: string[] = [];
    for (const token of cleanTokens) {
        const city = findPricesCityByName(token);
        if (city) {
            cityTokens.push({token, citySlug: city.slug, canonical: city.name});
        } else {
            otherTokens.push(token);
        }
    }

    const lastOtherToken = otherTokens[otherTokens.length - 1];
    const numberToken = cleanTokens.length > 1 && lastOtherToken !== undefined && isHouseNumberToken(lastOtherToken) ? lastOtherToken : undefined;
    const restTokens = numberToken === undefined ? otherTokens : otherTokens.slice(0, -1);

    const resolved = resolveQueryDiacritics(cleanTokens);
    const rcnQuery = limitRcnQueryTokens(resolved.tokens).join(" ");

    return {
        raw,
        tokens,
        cityTokens,
        ...(numberToken === undefined ? {} : {numberToken}),
        restTokens,
        rcnQuery,
        // RCN matches street diacritics literally: "puławska" and "pulawska" are different requests, so different phrases.
        baseKey: rcnQuery,
        ...(resolved.isRewritten ? {diacriticPhrase: rcnQuery} : {})
    };
};
